<template>
  <div :class="['badge', rounded ? 'rounded-pill' : '', bgClass]" :title="tooltip">
    <slot>
      <p :class="['m-0', contentClass]">{{ defaultContent }}</p>
    </slot>
  </div>
</template>

<script setup>
defineProps({
  tooltip: {
    type: String,
    required: false,
    default: ''
  },
  rounded: {
    type: Boolean,
    required: false,
    default: true
  },
  textClass: {
    type: String,
    required: false,
    default: 'text-white'
  },
  bgClass: {
    type: String,
    required: false,
    default: 'bg-danger'
  },
  contentClass: {
    type: String,
    required: false,
    default: ''
  },
  defaultContent: {
    type: String,
    required: false,
    default: ''
  }
})
</script>

<style scoped>
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
